import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hideItem: {
		id: 'navigation-kit-tab-menu.hide-item.hide-item',
		defaultMessage: 'Remove',
		description: 'Remove view option in the project navigation context menu.',
	},
});
